module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("liveshow_link", [["div",{"class":"link liveshows"},[["a",{"href":"/liveshow","class":"text-color-1"},[["i",{"class":"ico icon-au_m_liveshows"}],["textNode",{"text":" Live Shows"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/layout/home/liveshowLink.tpl
// module id = 1052
// module chunks = 4